import React from 'react'
import {Container} from 'react-bootstrap'
import {GiTechnoHeart} from 'react-icons/gi'

const Footer = () => {
    return (
        <Container className="footer-container">
            <p>Republic Of Anime &copy; 2021. All Rights Reserved. Made with
                <GiTechnoHeart/></p>
        </Container>
    )
}
export default Footer